import { createQueryKey } from '../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../query/types';

const officerTypeKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys, 'officerTypes'] as const,
    id: <U extends QueryKeyParam>(itemId: U) =>
      createQueryKey({
        all: [...keys, 'officerTypes', itemId] as const,
        detail: [...keys, 'officerTypes', itemId, 'detail'] as const,
      }),
    export: [...keys, 'export'] as const,
  });

export { officerTypeKeys };
